/**
 * @desc axios下载文件
 * @author TangYong
 * @param url 下载路径
 * @param fileName 下载的文件名称及其后缀，后缀要和后台保持的一致
 */

import axios from 'axios';

export const downloadFile = (url, fileName) => {
  axios.get(url, {responseType: 'blob'}).then(res => {
    const blob = new Blob([res.data]);
    if ('download' in document.createElement('a')) { // 非IE下载
      const link = document.createElement('a');
      link.download = fileName;
      link.style.display = 'none';
      link.href = URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href); // 释放URL 对象
      document.body.removeChild(link);
    } else { // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  });
};

/**
 * 二进制文件流下载
 * @param {BlobPart} data 文件流
 * @param {string} fileName 下载文件名
 */
export function downloadBlob(data, fileName) {
  const blob = new Blob([data]);
  const link = document.createElement('a');
  link.download = fileName;
  link.style.display = 'none';
  link.href = URL.createObjectURL(blob);
  link.click();
  URL.revokeObjectURL(link.href);
}
